import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { useMount } from 'react-use';
import ContentThree from './ContentThree';

export type ContentThreeContainerProps = {};

export function ContentThreeContainer(_props: ContentThreeContainerProps) {
  const dispatch = useDispatch();
  const keyframes = useSelector(selectors.base.$keyframes);
  const storyLines = useSelector(selectors.base.$storyLines);
  const animationState = useSelector(selectors.raw.$rawAnimationState);

  useMount(() => {
    dispatch({ type: 'ANIMATION', verb: 'play' });
  });

  const callbacks = useMemo(
    () => ({
      onLoad: () => {
        // dispatch({ type: 'THREE' });
      },
      onAction: (actionType: string, verb: string) => {
        dispatch({ type: actionType, verb });
      },
    }),
    []
  );

  useMount(() => {
    dispatch({ type: 'THREE' });
  });

  return (
    <ContentThree
      keyframes={keyframes}
      storyLines={storyLines}
      callbacks={callbacks}
      animationState={animationState}
    />
  );
}

export default ContentThreeContainer;
